export const getUserPreferences = (data, preferenceKeys) => {
	return preferenceKeys.map(
		preferenceKey => data.find(o => o.preferenceKey === preferenceKey)?.value
	);
};

export const getUserPreferenceValue = (userPreference, preferenceKey) =>
	userPreference.find(preference => preference.preferenceKey === preferenceKey)
		.value;
